import React, { useState } from "react";
import { Clue } from "../../Clue/Clue";
import "./Copy.css";

interface CopyProps {
  value?: string | null;
  tooltip?: string;
  children?: React.ReactNode;
}

export const Copy: React.FC<CopyProps> = ({
  value = null,
  tooltip = "Скопировано",
  children,
  ...props
}) => {
  const [isCopied, setCopied] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handleCopy();
  };

  const handleCopy = () => {
    if (!value) {
      console.error("No value provided for copying.");
      return;
    }

    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 10000);
      })
      .catch((error) => {
        console.error("Не удалось скопировать текст: ", error);
      });
  };

  return (
    <>
      <div className="copy-object" onClick={handleClick} {...props}>
        {children}
      </div>
      {isCopied && <Clue>{tooltip}</Clue>}
    </>
  );
};
